/**
 * The Ankiety tab's „Przypisane ankiety": the templates list (`entities/survey-template`, one cache
 * entry shared with `/raporty` and the assign dialog, which invalidates it), projected to this client.
 */

import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { surveyGroups, surveyTemplatesQueryOptions } from '~/entities/survey-template';

import { enrolledSurveys, type EnrolledSurvey } from '../model/enrolledSurveys';

export interface EnrolledSurveysState {
  /** `null` while the read is open and after it failed. */
  readonly enrolled: readonly EnrolledSurvey[] | null;
  readonly pending: boolean;
  readonly failed: boolean;
  readonly retry: () => void;
}

export function useEnrolledSurveys(clientId: number): EnrolledSurveysState {
  const { t, i18n } = useTranslation();
  const templates = useQuery(surveyTemplatesQueryOptions());
  return {
    enrolled: templates.isSuccess
      ? enrolledSurveys(surveyGroups(templates.data, i18n.language), clientId, t)
      : null,
    pending: templates.isPending,
    failed: templates.isError,
    retry: () => {
      void templates.refetch();
    },
  };
}
